import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoFamiliarPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoFamiliarPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexTipoFamiliar(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoFamiliar', name: 'TipoFamiliar', title: 'Tipo Familiar' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            tipofamiliar: {},           
        };
    },
    methods: {

        newTipoFamiliar() {
            this.tipofamiliar = {};
            this.$refs['frm-tipofamiliar'].show();
        },
        showTipoFamiliar(id) {
            this.isLoading=true;
            this.ss.showTipoFamiliar(id).then(
                (result) => {
                    let response = result.data;
                    this.tipofamiliar = response.data;
                    this.$refs['view-tipofamiliar'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoFamiliar() {
            this.$refs['frm-tipofamiliar'].show();
            this.$refs['view-tipofamiliar'].hide();
        },
        cancelTipoFamiliar() {
            if (this.tipofamiliar.id) {
                this.$refs['view-tipofamiliar'].show();
            }
            this.$refs['frm-tipofamiliar'].hide();
        },
        saveTipoFamiliar() {
            this.ss.storeTipoFamiliar(this.tipofamiliar).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipofamiliar'].hide();
                    this.$refs['datatable-tipofamiliar'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoFamiliar() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoFamiliar(this.tipofamiliar)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipofamiliar'].hide();
                                this.$refs['datatable-tipofamiliar'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },

        draw() {
            window.$('.btn-datatable-TipoFamiliar').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoFamiliar(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
